import * as Classes from '../common/classes';
import * as React from 'react';
import { Navbar, NAVBAR_DEFAULT_WIDTH } from './Navbar';

import { AppMenuProps, NavMenu } from './NavMenu';
import classNames from 'classnames';
import { UserMenuProps } from './UserMenu';
import { BaseProps } from '../common/props';
import { TestEnvironmentBar } from '../test-environment-bar/TestEnvironmentBar';
import { useAppConfig } from '@mc/react-app-base';
import {
  SidePanelItem,
  SidePanelItemActionEnum,
  SidePanelProps,
} from '../app/AppLayout';
import { BadgeCount } from '../badge-count/BadgeCount';
import { useEffect, useMemo } from 'react';
import { NavbarButton } from '../button/NavbarButton';

export type NavBarAppMenuProps = AppMenuProps;

export type NavBarProps = {
  /*
   * V základu false, pokud nastaveno jako true, navbar automaticky zobrazí a připne appMenu, dokud si to uživatel neodepne ručně.
   * Pokud je ale počet položek v menu 0, tak se i když je true se panel nezobrazí.
   */
  defaultVisibleMenu?: boolean;
  brand?: React.ReactNode;
  icon?: React.ReactNode;
  center?: React.ReactNode;
  appMenu?: NavBarAppMenuProps;
  userMenu?: UserMenuProps;
  navbarMenuActions?: React.ReactNode;
};

export type NavBarMenuLayoutProps = BaseProps & {
  sidePanel?: SidePanelProps;
} & {
  navbar?: NavBarProps;
};

//asi trochu hack, ale dělá to co chci
export const NavBarMenuLayout: React.FC<NavBarMenuLayoutProps> = ({
  children,
  className,
  style,
  navbar,
  sidePanel,
}) => {
  const appConfig = useAppConfig();
  const getDefaultState = () => {
    const pinned = localStorage.getItem('pinnedPanel');
    if (pinned !== null) {
      return Boolean(JSON.parse(pinned || 'false'));
    } else {
      return navbar?.defaultVisibleMenu;
    }
  };
  //@ts-ignore
  const isUnderEl = (parentEl, el) => {
    while (el !== null) {
      if (el === parentEl) {
        return true;
      }
      el = el.parentNode;
    }
    return false;
  };
  const popUpRef = React.useRef(null);
  const sidePanelButtonsRef = React.useRef(null);
  const [pinned, setPinned] = React.useState(getDefaultState());
  const togglePin = () => {
    localStorage.setItem('pinnedPanel', JSON.stringify(!pinned));
    setPinned(!pinned);
  };
  const [selectedSidePanelItemKey, setSelectedSidePanelItemKey] =
    React.useState<string | undefined>();
  const handleSidePanelItemChange = (item: SidePanelItem) => {
    if (selectedSidePanelItemKey === item.key) {
      setSelectedSidePanelItemKey(undefined);
    } else {
      setSelectedSidePanelItemKey(item.key);
    }
  };

  const selectedSidePanelItem = useMemo(() => {
    if (!selectedSidePanelItemKey) {
      return undefined;
    }
    return sidePanel?.items.find(
      (item) => item.key === selectedSidePanelItemKey
    );
  }, [selectedSidePanelItemKey, sidePanel?.items]);

  const closePopUpPanel = (ev: MouseEvent) => {
    if (selectedSidePanelItem?.action === SidePanelItemActionEnum.POPUP) {
      if (
        !isUnderEl(popUpRef.current, ev.target) &&
        !isUnderEl(sidePanelButtonsRef.current, ev.target)
      ) {
        setSelectedSidePanelItemKey(undefined);
      }
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', closePopUpPanel, false);
    document.addEventListener('click', closePopUpPanel, false);
    //window.addEventListener('resize', closePopUpPanel, false);
    return () => {
      document.removeEventListener('mousedown', closePopUpPanel, false);
      document.removeEventListener('click', closePopUpPanel, false);
      // window.removeEventListener('resize', closePopUpPanel, false);
    };
    //možná neoptimální
  }, [selectedSidePanelItem]);
  const renderSelectedItemContent = () => {
    if (!selectedSidePanelItem?.content) {
      return null;
    }
    /*HACK jako prase, ale kvůli zpětné kompabilitě a "multi" využití ténto komponenty je potřeba podporovat react komponentu
     * tak i funkci co přejímá parametr close a renderuje react komponentu
     */
    const content = selectedSidePanelItem.content;
    if (typeof content === 'function') {
      return content(() => setSelectedSidePanelItemKey(undefined));
    } else {
      return content;
    }
  };

  const computedPinned =
    navbar?.appMenu?.menuItems && navbar.appMenu.menuItems.length > 0
      ? pinned
      : false;

  return (
    <div
      className={classNames(className, Classes.APP_LAYOUT_WRAPPER)}
      style={style}
    >
      <div>
        <Navbar
          onClick={navbar?.appMenu?.onClick}
          icon={navbar?.icon}
          pinned={computedPinned}
          menuItems={navbar?.appMenu?.menuItems ? navbar.appMenu.menuItems : []}
          togglePin={togglePin}
          currentKey={navbar?.appMenu?.currentKey}
          userMenu={navbar?.userMenu}
          panelWidth={navbar?.appMenu?.panelWidth}
        >
          <div className={classNames(Classes.TITLE_H3, Classes.NAVBAR_BRAND)}>
            {navbar?.brand}
            {appConfig.testEnvironment && <TestEnvironmentBar />}
          </div>
          <div className={Classes.NAVBAR_CENTER}>{navbar?.center}</div>
          {sidePanel && sidePanel.items.length > 0 && (
            <div className={Classes.NAVBAR_RIGHT}>
              <div
                className={Classes.NAVBAR_RIGHT_CONTENT}
                ref={sidePanelButtonsRef}
              >
                {sidePanel.items.map((item) => {
                  const tempItem = {
                    ...item,
                    type:
                      !item.action && !item.onClick
                        ? SidePanelItemActionEnum.PIN_PANEL
                        : item.action,
                  };
                  const button = (
                    <NavbarButton
                      icon={item.icon}
                      key={item.key}
                      onClick={
                        tempItem.action === SidePanelItemActionEnum.ON_CLICK
                          ? tempItem.onClick
                          : () => handleSidePanelItemChange(tempItem)
                      }
                      style={
                        selectedSidePanelItem?.key !== tempItem.key
                          ? 'link'
                          : 'default'
                      }
                      title={tempItem.label}
                    />
                  );
                  return tempItem.count ? (
                    <BadgeCount
                      count={tempItem.count}
                      intent={tempItem?.countIntent ?? 'danger'}
                    >
                      {button}
                    </BadgeCount>
                  ) : (
                    button
                  );
                })}
              </div>
            </div>
          )}
        </Navbar>
      </div>
      <div
        id={'containerVyskaId'}
        className={Classes.APP_LAYOUT_BASE_NAVBAR_CONTENT}
      >
        {computedPinned && navbar?.appMenu && (
          <div
            className={classNames(
              Classes.NAVBAR_MENU_CONTAINER,
              Classes.INVERSE_SCROLL_CONTAINER
            )}
          >
            <NavMenu
              onClick={navbar?.appMenu?.onClick}
              currentKey={navbar?.appMenu?.currentKey}
              menuItems={navbar.appMenu.menuItems}
              panelWidth={navbar?.appMenu?.panelWidth}
              scrollWrapStyle={{
                minWidth:
                  (navbar?.appMenu?.panelWidth ?? NAVBAR_DEFAULT_WIDTH) - 14, // Respektování gutteru
              }}
            />
          </div>
        )}
        <div className={Classes.APP_LAYOUT_BASE_APP_CONTENT}>{children}</div>
        {selectedSidePanelItem?.action ===
          SidePanelItemActionEnum.PIN_PANEL && (
          <div
            className={Classes.NAVBAR_ACTION_ITEM_MENU_PINNED}
            style={{
              minWidth: sidePanel?.panelWidth ?? 200,
              maxWidth: sidePanel?.maxWidth,
            }}
          >
            {renderSelectedItemContent()}
          </div>
        )}
        {selectedSidePanelItem?.action === SidePanelItemActionEnum.POPUP && (
          <div
            ref={popUpRef}
            className={Classes.NAVBAR_ACTION_ITEM_MENU_POPOVER}
            style={{
              minWidth: sidePanel?.panelWidth ?? 200,
              maxWidth: sidePanel?.maxWidth,
            }}
          >
            <div className={Classes.NAVBAR_ACTION_ITEM_MENU_POPOVER_CONTENT}>
              {renderSelectedItemContent()}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
